<template>
    <v-data-table
        v-bind="{
            headers,
            items,
        }"
        disable-sort
        disable-filtering
        disable-pagination
        hide-default-footer
        class="time-form"
    >
        <template #top>
            <v-divider class="primary border-2" />
        </template>
        <template v-for="header in headers.filter((header) => header.value != 'times')" #[`item.${header.value}`]="{ item }">
            <table-cell
                v-model="form"
                :key="`${header.value}-${item.time}`"
                v-bind="{
                    mode,
                    employer,
                    matchings,
                    isUserEmployee,
                    isUserEmployer,

                    date: header.value,
                    time: item.time,
                }"
                @input="emit"
            />
        </template>
        <template #footer>
            <v-divider />
        </template>
    </v-data-table>
</template>

<script>
import { initExpoEmployer, initExpoMatching, initExpoProgram } from "@/assets/variables/inits";

import TableCell from "./table/table-cell.vue";

export default {
    components: {
        TableCell,
    },
    props: {
        mode: { type: String, default: "form" },
        value: { type: Object, default: initExpoMatching }, // form
        program: { type: Object, default: initExpoProgram },
        employer: { type: Object, default: initExpoEmployer },
        matchings: { type: Array, default: () => [] },
        isUserEmployee: { type: Boolean, default: false },
        isUserEmployer: { type: Boolean, default: false },
    },
    data: () => ({
        form: initExpoMatching(),
    }),
    computed: {
        headers() {
            let items = [
                {
                    text: "시간",
                    value: "times",
                    width: 160,
                },
            ];

            const { startsAt, endsAt } = this.program.date.interviewSpans;
            do {
                let date = items.at(-1).value;
                switch (date) {
                    case "times": {
                        date = startsAt.toDate();
                        break;
                    }

                    default: {
                        date = this.$dayjs(date).add(1, "day").format("YYYY-MM-DD");
                        break;
                    }
                }

                items.push({
                    text: this.$dayjs(date).format("M/D"),
                    value: date,
                });

                if (this.$dayjs(date).isSame(endsAt, "date")) break;
            } while (true);

            return items.map((item) => ({
                ...item,
                align: "center",
                cellClass: "pa-0",
            }));
        },
        items() {
            return new Array(9).fill(8).map((_, index) => {
                const time = index + 9;

                const times = [time, time + 1].map((time) => this.$dayjs(Date.now().toDate()).set("hour", time).format("HH:mm")).join("~");

                return { time, times };
            });
        },
    },
    methods: {
        sync() {
            this.form = initExpoMatching(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style lang="scss" scoped>
.time-form ::v-deep {
    tr > th:first-of-type,
    tr > td:first-of-type {
        position: sticky;
        left: 0;
        background-color: white;

        &::after {
            content: " ";
            position: absolute;
            top: 0;
            right: 0;
            height: 100%;
            width: 1px;
            border-right: thin solid rgba(0, 0, 0, 0.12);
        }
    }
    tr > th:first-of-type {
        z-index: 4 !important;
    }
    tr > td:first-of-type {
        z-index: 3 !important;
    }
    tr > td {
        height: 48px !important;
    }

    th,
    td {
        max-width: 0;
        min-width: 80px;
    }
}
</style>
